import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const VatField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="vatLabel" value={restaurantForFullInfo?.terminal} />;
};

export default VatField;
